import React, { useEffect, useMemo, useState } from 'react'
import { Col, Row } from "react-bootstrap";
import "../Style.css";
import PartnerlistWithPayout from "./PartnerlistWithPayoutChecker";
import { Button, Checkbox, message, Radio } from "antd";
import LanlistWithPayoutChecker from './LanlistWithPayoutChecker';
import { datasocurceLanPayout } from '../helper/payoutdatasample';
import { connect } from 'react-redux';
import Logout from '../../../containers/Pages/Login/Logout';
import { useLocation, useNavigate } from 'react-router-dom';
import { payoutLandataAction, payoutPartnerLansearch } from '../../../redux/PayoutLanData/Action';
import useSession from '../../CustomLogout/useSession';
import { miscellaneousListSuccess } from '../../../redux/PayoutMiscellaneous/Action';
import { Table } from 'antd';
import { LeftCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { debounce } from 'lodash';


const LanListbypartnerChecker = (props) => {

  const [landatasource, setLanDatasource] = useState([]);
  const [makerAction, setMakerAction] = useState(false);
  const [checkerAction, setCheckerAction] = useState(false);
  const [searchTextTable, setSearchTextTable] = useState("");
  const [radiostate, setRadioState] = useState("All");
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({ Check: [] });
  const navigate = useNavigate();
  const handleSessionExpired = useSession();
  const [holdAction, setHoldAction] = useState(false);
  const location = useLocation();
  const ReportId = location.state?.ReportId;
  const partnerId = location.state?.partnerId;
  const partnerName = location.state?.partnerFirmName || "partner Name";
  const [remapAction, setRemapAction] = useState(false);
  const [downloadAction, setDownloadAction] = useState(false);
  const currentStage = location.state?.currentStage;
  const [recovery, setRecovery] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100', '200'],
  });
  const [mAdjustment, setmAdjustment] = useState(false);
  const [entryData, setEntryData] = useState([]);
  const [rows, setRows] = useState([]);
  const [fileApprovalId, setFileApprovalId] = useState();
  const [remap, setRemap] = useState(false);


  useEffect(() => {

    handleRadioChange(radiostate, datasocurceLanPayout)
  }, []);

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const options = [
    {
      label: <div
        style={{
          position: "relative",
          fontSize: "0.8rem",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >ALL</div>,
      value: "All"
    },
    {
      label: <div
        style={{
          position: "relative",
          fontSize: "0.8rem",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >Regular Cases</div>, value: "REGULAR"
    },
    {
      label: <div
        style={{
          position: "relative",
          fontSize: "0.8rem",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >Remap Cases</div>, value: "REMAP"
    },
    {
      label: <div
        style={{
          position: "relative",
          fontSize: "0.8rem",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >Cases on Hold</div>, value: "ONHOLD"
    },
    {
      label: <div
        style={{
          position: "relative",
          fontSize: "0.8rem",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >Recovery</div>, value: "RECOVERY"
    },
    {
      label: <div
        style={{
          position: "relative",
          fontSize: "0.8rem",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >Retrospective Adjustment</div>, value: "RETRO"
    },
    {
      label: (
        <div
          style={{
            position: "relative",
            fontSize: "0.8rem",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          Miscellaneous Entry
        </div>
      ),
      value: "MANUALADJUSTMENT",
    },
  ];

  useEffect(() => {
  }, [selectedCheckboxes]);

  const handleCheckboxChange = (e, column, rowId) => {
    const isChecked = e.target.checked;
    setSelectedCheckboxes((prevState) => {
      const newState = { ...prevState };
      if (isChecked) {
        newState[column] = [...newState[column], rowId];
      } else {

        newState[column] = newState[column].filter((item) => item !== rowId);
      }
      return newState;
    });
  };



  const fetchPaginatedData = async (lanStag) => {
    setDownloading(true);
    try {
      let current = pagination.current || 1;
      let pageSize = pagination.pageSize || 10;
      let response;
      let data = [];


      if (lanStag === "MANUALADJUSTMENT") {
        response = await props.miscellaneousListSuccess({
          accessToken: props.accessToken,
          partnerId: partnerId,
          reportId: ReportId,
        });
      } else {
        response = await props.payoutLanDataSuccess({
          accessToken: props.accessToken,
          reportId: ReportId,
          partnerId: partnerId,
          tab: lanStag,
          page: current,
          records: pageSize,
        });
      }
      // const response = await props.payoutLanDataSuccess({
      //   accessToken: props.accessToken,
      //   reportId: ReportId,
      //   partnerId: partnerId,
      //   tab: lanStag,
      //   page: current,
      //   records: pageSize,
      // });

      if (lanStag === "MANUALADJUSTMENT") {
        data = response || [];
      } else {
        data = response.payoutLanReport || [];
      }
      const errorCode = response?.response?.data?.error?.errorCode || response?.response?.status;
      if (errorCode && errorCode === "403" && (response?.response?.data?.error?.errorCode || response?.response?.status)) {
        handleSessionExpired(); //Logout the user if session expired
        return;
      }
      setFileApprovalId(response?.reportStageId)
      setPagination((prev) => ({
        ...prev,
        current,
        pageSize,
        total: response?.totalElements,
      }));
      if (lanStag === "MANUALADJUSTMENT") {
        setmAdjustment(true);
        // setismAdjustmentMod(false);

        const mapdata = data.map((item, index) => ({
          srNo: index + 1,
          ReferenceNumber: item.referenceNumber || "",
          ReferenceDate: item.referenceDate ? item.referenceDate : null,
          Description: item.comments || "",
          CreditAmt: item.creditAmount || 0,
          DebitAmt: item.debitAmount || 0,
          adjustmentId: item.adjustmentId,
          partnerId: item.partnerId,
          adjustmentDate: item.adjustmentDate ? item.adjustmentDate : null,
          isDeleted: item.isDeleted,
        }));
        setEntryData(mapdata);
        setRows([]);

      } else {
        setmAdjustment(false);
        setLanDatasource(data);
      }
      setLanDatasource(data);
      setMakerAction(lanStag === "REGULAR");
      setCheckerAction(lanStag === "ONHOLD" || lanStag === "REMAP");
      setRecovery(lanStag === "RECOVERY");
      setRemap(lanStag === "REMAP")
      setDownloadAction(lanStag === "All");
      setSelectedCheckboxes({ Check: [] });
      setRadioState(lanStag);
    } catch (error) {
      console.error("Error fetching paginated data:", error);
      message.error("Failed to fetch data. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  const handlePageChange = async (page, pageSize, lanStag) => {

    // Call the API with the new page and pageSize
    const payoutPartnerResponse = await props.payoutLanDataSuccess({
      accessToken: props.accessToken,
      reportId: ReportId,
      partnerId: partnerId,
      tab: lanStag,
      page: page,
      records: pageSize,

    });
    const res = payoutPartnerResponse;
    setLanDatasource(res.payoutLanReport || []);
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize,
      total: res?.totalElements,
    }));
    // setPagination((prev) => ({
    //   ...prev,
    //   total: res?.totalElements,
    // }));
  };

  const handleRadioChange = async (value, data = datasocurceLanPayout) => {

    switch (value) {
      case "All":

        fetchPaginatedData("All");
        break;

      case "REGULAR":

        fetchPaginatedData("REGULAR");
        break;

      case "REMAP":

        fetchPaginatedData("REMAP");
        setRemapAction(true);
        break;

      case "RECOVERY":

        fetchPaginatedData("RECOVERY");
        break;

      case "ONHOLD":

        fetchPaginatedData("ONHOLD");
        setHoldAction(true);
        break;

      case "RETRO":

        fetchPaginatedData("RETRO");
        break;

      case "MANUALADJUSTMENT":
        fetchPaginatedData("MANUALADJUSTMENT");
        break;


      default:
        break;
    }
  };


  const debouncedSearch = useMemo(() =>
    debounce(async (value) => {
      const searchValue = String(value || "").trim().toLowerCase();


      if (!searchValue) {
        setPagination(prev => ({
          ...prev,
          current: 1,
          pageSize: 10,
        }));
        await fetchPaginatedData(radiostate);
        return;
      }

      try {

        // setLoading?.(true);


        let response = await props.payoutPartnerLansearch({
          accessToken: props.accessToken,
          reportId: ReportId,
          lanTab: radiostate,
          lanNo: searchValue,
          partnerId: partnerId
        });



        if (!response || response?.payoutLanReport.length === 0) {
          response = await props.payoutPartnerLansearch({
            accessToken: props.accessToken,
            reportId: ReportId,
            lanTab: radiostate,
            applicantName: searchValue,
            partnerId: partnerId
          });
        }


        const searchData = response || [];
        const lanReportData = searchData.payoutLanReport || [];




        setLanDatasource(lanReportData);


        const totalResults = lanReportData.length;
        setPagination(prev => ({
          ...prev,
          current: 1,
          total: totalResults,
          pageSize: totalResults > 0 ? totalResults : 10,
        }));



      } catch (error) {
        message.error("Search failed. Please try again.");

        // Optional: Reset to original data on error
        // await fetchPaginatedData(radiostate);

      } finally {
        // setLoading?.(false);
      }
    }, 300),
    [props.accessToken, ReportId, radiostate, partnerId]
  );


  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTextTable(value);
    debouncedSearch(value);
  };


  return (
    <div className="" style={{ maxWidth: "100%" }}>
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar">
            <Button
              type="default"
              style={{
                margin: "0",
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '2px', // space between icon and text
                padding: '0 8px',
                color: '#00b1b1',
              }}
              onClick={() => navigate(-1)}
            >
              <LeftCircleOutlined />
              <span>Back</span>
            </Button>
          </Col>
          <Col md={4}>
            <div className="login-profie">
              <div className="img-sec">
                <h2>
                  {adminFirstName(
                    props.userDetail?.firstName ??
                    props.userDetail?.userName?.split(" ")[0]?.trim()
                  )}

                </h2>
                <h2>
                  {adminLastName(
                    props.userDetail?.lastName ??
                    props.userDetail?.userName?.split(" ")[1]?.trim()
                  )}
                </h2>
              </div>

              <div className="content-login">
                <h4>{props.userDetail?.userName}</h4>
                <h5>{props.userDetail?.roleName}</h5>

                <div className="content-login-data">
                  {/* <ChangePassword /> */}
                  <div className="admin-small-space"> </div>

                  <Logout />
                  {/* <h6>Change Password | Logout</h6> */}
                </div>
              </div>
            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <Col md={6} style={{ display: "flex" }} className="btn-partner">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5
                style={{ fontWeight: 700, fontSize: "0.9rem", }}
              >
                Partner :{" "}
                <span style={{ color: "#35cd7a" }}>{partnerName}</span>
              </h5>

            </div>
          </Col>
        </Col>
      </Row>

      <Row>
        <div style={{ marginTop: 30, display: "flex" }}>
          <Col md={9}>
            <div className="buckets-container" style={{ width: "100%", overflowX: "auto", whiteSpace: "nowrap" }}>
              <Radio.Group
                block
                options={options}
                defaultValue="All"
                onChange={(e) => {
                  handleRadioChange(e.target.value);
                }}
                optionType="button"
                buttonStyle="solid"
                buttonCheckedBg="#1b8593"
              />
            </div>
          </Col>
          <Col
            md={3}
            style={{
              display: "flex",
              justifyItems: "end",
              alignItems: "end",
              justifyContent: "end",
            }}
          >

            {/* <Button className='ant-btn-next ' type="primary" onClick={handleNextCase} style={{ fontSize: '0.8rem', backgroundColor: '#1b8593', color: '#fff', margin: '5px', borderRadius: '5px', width: "90px", height: 90, border: "none", marginBottom: '20px' }} >Next</Button> */}
            {/* <Button className='ant-btn ant-btn-default ' style={{marginLeft:10, backgroundColor:'#1b8593', color:'#fff',fontSize:'0.7rem',margin:'3px',borderRadius:'5px'}}>Approve</Button> */}

          </Col>
        </div>
      </Row>



      <Row style={{ display: "flex" }}>
        {!mAdjustment ?
          <>
            <Col
              md={9}
              style={{
                display: "flex",
                justifyItems: "end",
                alignItems: "end",
                justifyContent: "end",
              }}
            ></Col>
            <Col
              md={3}
              style={{
                display: "flex",
                justifyItems: "end",
                alignItems: "end",
                justifyContent: "end",
              }}
            >
              <Input
                //  disabled={!searchlandatasource.length}
                className="search-input"
                allowClear
                placeholder="Search..."
                suffix={<SearchOutlined />}

                value={searchTextTable}
                onChange={handleSearch}
                style={{ width: 200 }}
              />
            </Col>
            <LanlistWithPayoutChecker
              landataSource={landatasource}
              makerAction={makerAction}
              checkerAction={checkerAction}
              setMakerAction={setMakerAction}
              setCheckerAction={setCheckerAction}
              setLanDatasource={setLanDatasource}
              handleRadioChange={handleRadioChange}
              radiostate={radiostate}
              setRadioState={setRadioState}
              handleCheckboxChange={handleCheckboxChange}
              selectedCheckboxes={selectedCheckboxes}
              setSelectedCheckboxes={setSelectedCheckboxes}
              partnerId={partnerId}
              ReportId={ReportId}
              fetchPaginatedData={fetchPaginatedData}
              holdAction={holdAction}
              setHoldAction={setHoldAction}
              remapAction={remapAction}
              setRemapAction={setRemapAction}
              pagination={pagination}
              onPageChange={handlePageChange}
              downloadAction={downloadAction}
              setDownloadAction={setDownloadAction}
              recovery={recovery}
              setRecovery={setRecovery}
              fileApprovalId={fileApprovalId}
              setFileApprovalId={setFileApprovalId}
              remap={remap}
              setRemap={setRemap}
              loading={downloading}
            // monthlyReportid = {ReportId}
            />
          </> : <Table
            dataSource={entryData}
            pagination={false}
            columns={[
              {
                title: "S. No",
                dataIndex: "srNo",
                key: "srNo",
                width: 70,
              },
              {
                title: "Reference Number",
                dataIndex: "ReferenceNumber",
                key: "ReferenceNumber",
              },
              {
                title: "Reference Date",
                dataIndex: "ReferenceDate",
                key: "ReferenceDate",
              },
              {
                title: "Description",
                dataIndex: "Description",
                key: "Description",
              },
              {
                title: "Credit Amount",
                dataIndex: "CreditAmt",
                key: "CreditAmt",
              },
              {
                title: "Debit Amount",
                dataIndex: "DebitAmt",
                key: "DebitAmt",
              },
              // {
              //   title: "Action",
              //   key: "Action",
              //   render: (_, data, idx) => (<> <Button danger 
              //     onClick={() => handleRemove(idx)}>
              //     <DeleteOutlined />
              //     </Button>|
              //     <Button info 
              //     onClick={() => handleEdit(idx, data?.adjustmentId?"entryData":"rows")}>
              //     <EditOutlined />
              //     </Button></>

              //   ),
              // },
            ]}

          //   rowKey="srNo"
          // {...(ismAdjustment ? { components } : {})}

          />
        }
      </Row>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    payoutLanDataSuccess: (data) => dispatch(payoutLandataAction(data)),
    miscellaneousListSuccess: (data) => dispatch(miscellaneousListSuccess(data)),
    payoutPartnerLansearch: (data) => dispatch(payoutPartnerLansearch(data))
  }
};

const mapStateToProps = (state) => {
  return {


    accessToken: state && state.auth && state.auth.idToken,
    userDetail: state.auth?.userData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LanListbypartnerChecker); 